import BaseService from "core/api/BaseService";

class StoryService extends BaseService {
  constructor() {
    super("/stories");
  }

  async getActiveStories(params = {}) {
    return this.get("", params);
  }

  async createStory(storyData) {
    return this.post("", storyData);
  }

  async viewStory(storyId) {
    return this.post(`${storyId}/view`);
  }

  async deleteStory(storyId) {
    return this.delete(`${storyId}`);
  }
}

export default new StoryService();
